export default "__VITE_ASSET__5tuSswik__"